import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';

@Component({
  selector: 'app-benefits-create-claim',
  templateUrl: './benefits-create.component.html',
  styleUrls: ['./benefits-create.component.scss'],
  standalone: false
})
export class BenefitsCreateClaimComponent implements OnInit {
  constructor(private router: Router) {}

  claimPageTitle = 'Create new claim';
  claimsBodyHeader = 'This feature is currently being redesigned';
  claimsBodySubHeader =
    'Check back soon for our improved experience. In the meantime, please follow these steps for creating a new claim:';
  claimsBody = [
    '1. Download and complete the claim packet',
    '2. Email or fax claim packet to Symetra',
    "3. We'll contact you for any additional details",
    "4. We'll send a confirmation letter with your claim number"
  ];
  ngOnInit(): void {}

  goFormsClaimPage() {
    this.router.navigate(['benefits/allforms/claimsform'], {
      queryParamsHandling: 'preserve'
    });
  }
}
